interface BrandLogoProps {
  readonly variant?: "lockup" | "mark" | "wordmark";
  readonly label?: string;
  readonly className?: string;
}

const SOURCES = {
  lockup: "/brand/pakplan-lockup.svg",
  mark: "/brand/pakplan-mark.svg",
  wordmark: "/brand/pakplan-wordmark.svg",
} as const;

/** Uses the reviewed public SVG assets without re-typesetting or altering the mark. */
export function BrandLogo({ variant = "lockup", label, className }: BrandLogoProps) {
  return (
    <img
      alt={label ?? ""}
      aria-hidden={label === undefined ? true : undefined}
      className={["brand-logo", `brand-logo-${variant}`, className].filter(Boolean).join(" ")}
      draggable={false}
      src={SOURCES[variant]}
    />
  );
}
